import { render, staticRenderFns } from "./barrageAd.vue?vue&type=template&id=883a37ec&scoped=true"
import script from "./barrageAd.vue?vue&type=script&lang=js"
export * from "./barrageAd.vue?vue&type=script&lang=js"
import style0 from "./barrageAd.vue?vue&type=style&index=0&id=883a37ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883a37ec",
  null
  
)

export default component.exports